
import { Button, ButtonGroup, Tooltip, Typography } from "@mui/material";
import { json, NavLink } from "react-router-dom";

import { Popconfirm } from "antd";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { Image } from "antd";
import Datatable from "../../../Comp/Table/Datatable";
import useStore from "../../../Hooks/useStore";
// import { axiosPrivate } from "../../../api/axios/axios";
import { Chip } from "@mui/material";
import AppConstrains from "../../../AppConstrains/AppConstrains";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
const ViewGroupComponent = ({ tableData, loading, setSearchTerm, setRowsPerPage, rowsPerPage, page, totalCount, setPage, }) => {
  const axiosPrivate = useAxiosPrivate();
  const { setFetchAgain } = useStore();

  

  const columns = [
    {
      name: "_id",
      label: "Action",
      options: {
        customBodyRender: (id) => {
          const fullRowData = tableData.find((data) => data._id === id);
          // console.log(fullRowData, "fullRowData");

          // let data = allStoresData.filter((row) => row.store_id === id)[0];
          return (
            <ButtonGroup orientation="vertical" variant="text" color="success">
              <NavLink to="/creategroup" state={{ fullRowData }}>
                <Button color="success">
                  <strong>Edit</strong>
                </Button>
              </NavLink>
              {/* <Popconfirm
                                placement="right"
                                title="Delete Store"
                                description="Do you really want to delete the store?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => console.log(id)}
                            >
                                <Button color="error">
                                    <strong>Delete</strong>
                                </Button>
                            </Popconfirm> */}
            </ButtonGroup>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "icon",
      label: "Icon",
      options: {
        customBodyRender: (link) => {
          return (
            <div
              // className="size-[40px] rounded overflow-hidden duration-150"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "4px",
                overflow: "hidden",
                transitionDuration: "0.150s",
              }}
            >
              <Image src={`${AppConstrains.imageURL}/group/` + link} />
            </div>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (name) => {
          const fullRowData = tableData.find((data) => data.name === name);
          return <Typography sx={fullRowData?.highlighted_text !== null?{
            color:"red",
          }:{}}>{name}</Typography>


        }
      },
    },
    {
      name: "defaultGroup",
      label: "DG",
      options: {
        customBodyRender: (defaultGroup) => {
          // console.log(defaultGroup, "defaultGroup");
          if (defaultGroup) return 1;
          else return 0;
          // return defaultGroup?.map((default) => {
          //   return (
          //     <Chip label={default} size="small" variant="outlined" />
          //   );
          // });
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "announcement",
      label: "Group Type",
      options: {
        customBodyRender: (announcement) => {
          if (announcement === true || announcement === "true") {
            return (
              <Chip
                label="Announcement"
                size="small"
                variant="outlined"
                style={{ color: "green", borderColor: "green" }}
              />
            );
          } else {
            return (
              <Chip
                label="Deals"
                size="small"
                variant="outlined"
                style={{ color: "red", borderColor: "red" }}
              />
            );
          }
        },
        filter: true,
        sort: true,
      },
    }
    ,
    {
      name: "categories",
      label: "Categories",
      options: {
        customBodyRender: (categories) => {
          return (
            <Tooltip
              title={categories?.map((category, index) => (
                <Chip
                  key={index}
                  label={category}
                  size="small"
                  sx={{ color: "white", margin: "4px" }}
                  variant="outlined"
                />
              ))}
              placement="top"
              arrow
            >
              <Typography
                sx={{
                  width: "120px",
                  lineClamp: "2",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {categories?.map((category, index) => {
                  return (
                    <Chip
                      key={index}
                      sx={{ marginRight: "2px" }}
                      label={category}
                      size="small"
                      variant="outlined"
                    />
                  );
                })}
              </Typography>
            </Tooltip>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "stores",
      label: "Stores",
      options: {
        customBodyRender: (stores) => {
          return (
            <Tooltip
              title={stores?.map((store, index) => (
                <Chip
                  key={index}
                  label={store}
                  size="small"
                  sx={{ color: "white", margin: "4px" }}
                  variant="outlined"
                />
              ))}
              placement="top"
              arrow
            >
              <Typography
                sx={{
                  width: "120px",
                  lineClamp: "2",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {stores?.map((store) => {
                  return (
                    <Chip
                      label={store}
                      sx={{ marginRight: "2px" }}
                      size="small"
                      variant="outlined"
                    />
                  );
                })}
              </Typography>
            </Tooltip>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "keywords",
      label: "Keywords",
      options: {
        customBodyRender: (keywords) => {
          return (
            <Tooltip
              title={keywords?.map((keyword, index) => (
                <Chip
                  key={index}
                  label={keyword}
                  size="small"
                  sx={{ color: "white", margin: "4px" }}
                  variant="outlined"
                />
              ))}
              placement="top"
              arrow
            >
              <Typography
                sx={{
                  width: "120px",
                  lineClamp: "2",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {keywords?.map((keyword) => {
                  return (
                    <Chip
                      label={keyword}
                      sx={{ marginRight: "2px" }}
                      size="small"
                      variant="outlined"
                    />
                  );
                })}
              </Typography>
            </Tooltip>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "priority",
      label: "Priority",
      options: {
        customBodyRender: (brand) => {
          return <div style={{ width: "12px" }}>{brand}</div>;
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "des",
      label: "Description",
      options: {
        customBodyRender: (des) => {
          return (
            <Tooltip title={des} placement="top" arrow>
              <Typography
                sx={{
                  width: "200px",
                  lineClamp: "2",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {des}
              </Typography>
            </Tooltip>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "active",
      label: "Status",
      options: {
        customBodyRender: (active, tableMeta) => {
          // console.log(active, "active");
          var data = {};
          data._id = tableMeta.rowData[0];
          data.active = active ? 1 : 0;
          if (active)
            return (
              <Popconfirm
                placement="topRight"
                title="Deactivate Store"
                description="Do you really want to deactivate the store?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleStatus(data)}
              >
                <Button color="error" size="small" variant="outlined">
                  <b>Deactivate</b>
                </Button>
              </Popconfirm>
            );
          else
            return (
              <Popconfirm
                placement="topRight"
                title="Activate Store"
                description="Do you really want to activate the store?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleStatus(data)}
              >
                <Button color="success" size="small" variant="outlined">
                  <b>Activate</b>
                </Button>
              </Popconfirm>
            );
        },
        filter: true,
        sort: true,
      },
    },
  ];

  const handleStatus = async (data) => {
    const UPDATE_DEAL_URL = "/api/deals/updateappdealsgroup";

    try {
      const response = await axiosPrivate.put(UPDATE_DEAL_URL, {
        _id: data._id,
        active: !data.active,
      });
      toast.success(response.data.msg);
      setFetchAgain((prev) => !prev);
    } catch (error) {
      toast.error(error.response.data.msg);
      console.log(error);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <Datatable
        name="Store Data"
        columns={columns}
        data={tableData}
        loading={loading}
        setSearchTerm={setSearchTerm}
        totalCount={totalCount}
        setPage={setPage}
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchPlaceholder="Search by Store Name"
      />
    </div>
  );
};
export default ViewGroupComponent;
